import { IQuoteSetting, IQuoteTyreOffer } from '~/purchase/types';
import { IUserCustomer } from '~/common/types';
import { QuoteProductResult, QuoteTableHeader } from '~/purchase/components';

type Props = {
  items: Array<IQuoteTyreOffer>;
  pointOfSaleView: boolean;
  requestedQuantity: number;
  customer: IUserCustomer;
  quoteSetting: IQuoteSetting;
  onRefreshTyre: (ean: string, quantity: number) => void;
};

function QuoteLinesDisplay({
  items,
  pointOfSaleView,
  requestedQuantity,
  customer,
  quoteSetting,
  onRefreshTyre,
}: Props) {
  return (
    <>
      <QuoteTableHeader pointOfSaleView={pointOfSaleView} />
      {items.map((item) => (
        <QuoteProductResult
          key={item.tyre.ean}
          tyreOffer={item}
          defaultQuantity={requestedQuantity}
          customer={customer}
          showBfDiscount={quoteSetting.showBfDiscount}
          pointOfSaleView={pointOfSaleView}
          onRefreshTyre={onRefreshTyre}
          type='LINE'
        />
      ))}
    </>
  );
}

export default QuoteLinesDisplay;
